module.exports = __webpack_public_path__ + "img/Error-500.cc3c6239.svg";